<template>
    <div class="np-captcha-container">
        <div class="np-captcha" v-if="captcha && captcha.length">
            <div
                v-for="(c, i) in captcha"
                :key="i"
                :style="{
                    fontSize: getFontSize() + 'px',
                    fontWeight: 800,
                    transform: 'rotate(' + getRotationAngle() + 'deg)',
                }"
                class="np-captcha-character">
                {{ c }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
    return {
      captchaLength: 5,
      captcha: [],
      captchaCurrent: ''
    };
  },
  methods: {
    createCaptcha() {
      let tempCaptcha = "";
      for (let i = 0; i < this.captchaLength; i++) {
        tempCaptcha += this.getRandomCharacter();
      }
      this.captcha = tempCaptcha.split("");
      this.$emit('toggle-favorite', tempCaptcha.toString().split('').reverse().join(''));
    },
    getRandomCharacter() {
      const symbols = "0123456789";
      const randomNumber = Math.floor(Math.random() * 10);
      // console.log(symbols[randomNumber]);
      return symbols[randomNumber];
    },
    getFontSize() {
      const fontVariations = [14, 20, 30, 36, 40];
      return fontVariations[Math.floor(Math.random() * 5)];
    },
    getRotationAngle() {
      const rotationVariations = [5, 10, 20, 25, -5, -10, -20, -25];
      return rotationVariations[Math.floor(Math.random() * 8)];
    },
  },
  mounted() {
    this.createCaptcha();
  },
}
</script>
<style scoped>
.np-captcha-container {
  background: #eee;
}
.np-captcha {
  font-size: 24px;
}
.np-button {
  padding: 6px 10px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 6px;
  font-size: 16px;
}
.np-captcha-character {
  display: inline-block;
  letter-spacing: 14px;
}
</style>